import React from "react";
import HelpText from "./help";
import CustomerDetailsField from "../proposal/partials/field";
import DownloadField from "../proposal/partials/download";
import withStyles from "@material-ui/core/styles/withStyles";
import { Box, Button, Grid, Typography } from "@material-ui/core";
import { useStyles } from "./dashboardStyles";
import moment from "moment";
import {
  isInitiateClaimButtonDisabled,
  isPolicyCancelled,
  isPlanExpired,
  isDaysPassed,
} from "../../helpers/proposal";
import {
  BUTTON_CANCELLATION_INITIATED,
  BUTTON_INITIATE_CLAIM,
  BUTTON_PENDING_COPAY,
  BUTTON_POLICY_CANCELLED,
  POLICY_CANCELED_STATUS_ID,
  CANCELLATION_INITIATED_WHAT_NEXT_TOOLTIP,
  CLAIM_REF_NO_TEXT,
  CLAIM_STATUS_INITIATED_SLUG,
  CLAIM_STATUS_REJECTED_SLUG,
  CLAIM_STATUS_CANCELLED_SLUG,
  CURRENT_POLICY_STATUS,
  FORMAT_DD_MM_YYYY,
  NEAREST_SERVICE_CENTRES_LIST,
  NOT_AVAILABLE_TEXT,
  PENDING,
  POLICY_CANCELLATION_INITIATED_STATUS_ID,
  REJECTION_REASON_TEXT,
  CANCELLATION_REASON_TEXT,
  RUPEE_SYMBOL,
  SERVICE_CENTRE_DETAILS,
  WHAT_NEXT_TEXT,
  WHAT_NEXT_TOOLTIP,
} from "../../constants";

function PolicyItem({
  classes: { buyButton, performanceCards, spacing },
  downloadFile,
  handleViewClick,
  item,
  index,
  onClickHandler,
}) {
  return (
    <Grid item md={4} key={index}>
      <Box className={performanceCards}>
        <Box className={`${spacing}`}>
          <Typography variant={"subtitle2"}>{item.product_name}</Typography>
        </Box>

        <Box className={isPolicyCancelled(item.status_id) && "policyCancelled"}>
          <Box className={spacing}>
            <CustomerDetailsField
              label={"Plan Number"}
              value={item.policy_number}
            />
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={6}>
              <CustomerDetailsField
                label={"Start Date"}
                value={moment(item.start_date).format(FORMAT_DD_MM_YYYY) ?? "-"}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomerDetailsField
                label={"End Date"}
                value={moment(item.end_date).format(FORMAT_DD_MM_YYYY) ?? "-"}
              />
            </Grid>
          </Grid>

          <Box className={spacing}>
            <CustomerDetailsField
              label={"IMEI Number"}
              value={item.responses.imei_number}
            />
          </Box>

          <Grid container spacing={3}>
            {/* <Grid item xs={6}>
              <CustomerDetailsField
                label={"Brand"}
                value={`${item.responses.phone_brand}`}
              />
            </Grid> */}
            <Grid item xs={6}>
              <CustomerDetailsField
                label={"Model"}
                value={`${item.responses.phone_model}`}
              />
            </Grid>
          </Grid>

          {/* <Grid container spacing={3}>
            <Grid item xs={6}>
              <CustomerDetailsField
                label={"Invoice Amount"}
                value={`${RUPEE_SYMBOL}${
                  item.responses.invoice_amount
                    ? Number(item.responses.invoice_amount).toLocaleString("en")
                    : "-"
                }`}
              />
            </Grid>
            <Grid item xs={6}>
              <CustomerDetailsField
                label={"Invoice No."}
                value={item.responses.invoice_number ?? "-"}
              />
            </Grid>
          </Grid> */}

          <Grid container spacing={3}>
            <Grid item xs={6}>
              <DownloadField
                label={"Invoice"}
                value="Download"
                isLink={true}
                url={item.responses.invoice}
                onClick={downloadFile}
              />
            </Grid>
            <Grid item xs={6}>
              <DownloadField
                label={"Plan Document"}
                value="Download"
                isLink={true}
                url={item.policy_schedule}
                onClick={downloadFile}
              />
            </Grid>
          </Grid>

          {item.claim_id && item.claim_payment_successful && (
            <>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <CustomerDetailsField
                    label={SERVICE_CENTRE_DETAILS}
                    value={item?.preferred_service_centre?.name}
                    primaryText={`Mobile: ${item?.preferred_service_centre?.mobile}<br />Email: ${item?.preferred_service_centre?.email}`}
                    secondaryText={`${item?.preferred_service_centre?.address?.address_line_1} ${item?.preferred_service_centre?.city} ${item?.preferred_service_centre?.state}, ${item?.preferred_service_centre?.pincode}`}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <CustomerDetailsField
                    label={"Preferred Date"}
                    value={
                      item?.claim_data?.inputs?.preferred_date
                        ? moment(item.claim_data.inputs.preferred_date).format(
                            FORMAT_DD_MM_YYYY
                          )
                        : "-"
                    }
                    // value={item.claim_data.inputs.preferred_date}
                  />
                </Grid>
                {/* <Grid item xs={6}>
                  <CustomerDetailsField
                    label={"Preferred Timeslot"}
                    value={item.claim_data.inputs.preferred_timeslot}
                  />
                </Grid> */}
              </Grid>

              {/* {item.estimated_by_service_centre && (
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <CustomerDetailsField
                      label={"Service Centre (Esimated By)"}
                      value={item?.estimated_by_service_centre?.name}
                      secondaryText={`${item?.estimated_by_service_centre?.address?.address_line_1} ${item?.estimated_by_service_centre?.address?.city} ${item?.estimated_by_service_centre?.address?.pincode}`}
                    />
                  </Grid>
                </Grid>
              )} */}

              {item.claimed_amount > 0 && (
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <CustomerDetailsField
                      label={"Claimed Amount"}
                      value={
                        item.claimed_amount
                          ? RUPEE_SYMBOL +
                            "" +
                            Number(item.claimed_amount).toLocaleString("en")
                          : PENDING
                      }
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <CustomerDetailsField
                      label={"Approved Amount"}
                      value={
                        item.approved_amount
                          ? RUPEE_SYMBOL +
                            "" +
                            Number(item.approved_amount).toLocaleString("en")
                          : PENDING
                      }
                    />
                  </Grid>
                </Grid>
              )}
            </>
          )}
        </Box>

        <Grid container spacing={3}>
          <Grid item xs={12}>
            {item.claim_id && item.claim_payment_successful && (
              <>
                <CustomerDetailsField
                  label={"Claim Status"}
                  value={
                    item.current_claim_status ? item.current_claim_status : NOT_AVAILABLE_TEXT
                  }
                  secondaryText={`(${
                    item.claim_id ? CLAIM_REF_NO_TEXT + item.claim_id : ""
                  })`}
                  variant={"subtitle1"}
                  icon={true}
                  colorClass={item.current_claim_status
                    .toLowerCase()
                    .replaceAll(" ", "_")}
                />

                {item.current_claim_status.toLowerCase() ===
                  CLAIM_STATUS_INITIATED_SLUG && (
                  <HelpText
                    className={""}
                    note={WHAT_NEXT_TEXT}
                    tooltip={WHAT_NEXT_TOOLTIP}
                  />
                )}

                {item.current_claim_status.toLowerCase() ===
                  CLAIM_STATUS_REJECTED_SLUG && (
                  <HelpText
                    className={"alternate"}
                    note={`${REJECTION_REASON_TEXT} ${item?.rejection_reason}`}
                  />
                )}

                {item.current_claim_status.toLowerCase() ===
                  CLAIM_STATUS_CANCELLED_SLUG && (
                  <HelpText
                    className={"alternate"}
                    note={`${CANCELLATION_REASON_TEXT} ${item?.cancellation_reason}`}
                  />
                )}

                <HelpText
                  className={"link"}
                  item={item}
                  note={NEAREST_SERVICE_CENTRES_LIST}
                  onClick={handleViewClick}
                  tooltip={""}
                />
              </>
            )}

            {isPolicyCancelled(item.status_id) && (
              <>
                <CustomerDetailsField
                  label={"Policy Status"}
                  value={
                    item.status_id === POLICY_CANCELED_STATUS_ID
                      ? BUTTON_POLICY_CANCELLED
                      : BUTTON_CANCELLATION_INITIATED
                  }
                  variant={"subtitle1"}
                  icon={false}
                  colorClass={
                    item.status_id === POLICY_CANCELED_STATUS_ID
                      ? "cancelled"
                      : "draft"
                  }
                />
                {item.status_id === POLICY_CANCELLATION_INITIATED_STATUS_ID && (
                  <HelpText
                    className={"draft"}
                    note={CURRENT_POLICY_STATUS}
                    tooltip={CANCELLATION_INITIATED_WHAT_NEXT_TOOLTIP}
                  />
                )}
              </>
            )}

            {item.claim_status === 'Initiatable' && !isPolicyCancelled(item.status_id) && isPlanExpired(item.end_date, item.server_timestamp.date) &&  (
                <Box display="flex" justifyContent={"center"} m={2}>
                    <Button
                        variant={"contained"}
                        color={"primary"}
                        className={buyButton}
                        onClick={(e) => {
                            onClickHandler(item);
                        }}
                        disabled={isInitiateClaimButtonDisabled(
                            item.product_id,
                            item.start_date,
                            item.end_date
                        )}
                    >
                        <b>{BUTTON_INITIATE_CLAIM}</b>
                    </Button>
                </Box>
            )}

            {!item.claim_status &&
              !isPolicyCancelled(item.status_id) &&
              isInitiateClaimButtonDisabled(
                item.product_id,
                item.start_date,
                item.end_date
              ) &&
              (item.product_id === 92 ? (
                <Typography variant={"body2"}>
                  {
                    "Plan begins after the expiry of the manufacturer's warranty."
                  }
                </Typography>
              ) : (
                <Typography variant={"body2"}>
                  {"You can initiate a claim request from " +
                    moment(isDaysPassed(new Date(item.start_date))).format(
                      FORMAT_DD_MM_YYYY
                    ) +
                    "."}
                </Typography>
              ))}

            {item.claim_id && item.claim_status !== 'Initiatable' &&
              !item.claim_payment_successful &&
              item.payment_link && (
                <Box display="flex" justifyContent={"center"} m={2}>
                  <Button
                    variant={"contained"}
                    color={"secondary"}
                    className={buyButton}
                  >
                    <b>{BUTTON_PENDING_COPAY}</b>
                  </Button>
                </Box>
              )}
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
}

export default withStyles(useStyles, { withTheme: true })(PolicyItem);
